import { render, staticRenderFns } from "./AttachmentRow.vue?vue&type=template&id=77b8bc3f&scoped=true&"
import script from "./AttachmentRow.vue?vue&type=script&lang=ts&"
export * from "./AttachmentRow.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentRow.vue?vue&type=style&index=0&id=77b8bc3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b8bc3f",
  null
  
)

export default component.exports